module.exports = __webpack_public_path__ + "media/forum/link_anchor-ae0dd5fb.svg";